<template>
    <org-unit-details :orgUnitId="props.orgUnitId">
        <div class="col-span-12 lg:col-span-10">
            <page-loading v-if="!orgUnit"></page-loading>
            <template v-else>
                <org-unit-proforma-invoices
                    v-if="orgUnit.is_billable"
                    :team-id="props.teamId"
                    :org-unit-id="orgUnit.id"
                    :payment-terms-days="orgUnit.payment_terms_days"
                />
            </template>
        </div>
    </org-unit-details>
</template>

<script setup>
import OrgUnitProformaInvoices from '~/components/settings/billing/OrgUnitProformaInvoices.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import OrgUnitDetails from '../form/OrgUnitDetails.vue';
import { ref, onMounted, watch } from 'vue';
import { orgUnitsClient } from '~/services';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const orgUnit = ref(null);
const $toasted = useToasted();

const getOrgUnit = async () => {
    try {
        const response = await orgUnitsClient.showOrgUnit(props.teamId, props.orgUnitId);
        orgUnit.value = response.data;
    } catch (error) {
        console.error('Failed to fetch org unit:', error);
        $toasted.error('Failed to load organizational unit details. Please try again.');
    }
};

onMounted(() => {
    getOrgUnit();
});

watch(
    () => props.orgUnitId,
    () => {
        getOrgUnit();
    }
);
</script>
